import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, isAdmin } from "../context/AuthContext";
import { errMessage } from "../lib/api";
import Seo from "../components/Seo";

export default function Login() {
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ email: "", password: "", display_name: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const user =
        mode === "login"
          ? await login(form.email, form.password)
          : await register({ email: form.email, password: form.password, display_name: form.display_name });
      toast.success("Bienvenue");
      navigate(isAdmin(user) ? "/admin" : "/compte");
    } catch (err) {
      const msg = errMessage(err);
      setError(msg);
      toast.error(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="login-page" className="max-w-md mx-auto px-6 py-24 lg:py-32">
      <Seo title="Connexion" description="Accédez à votre compte VytaliBoots." path="/connexion" noindex />
      <h1 className="vb-display text-4xl font-black">{mode === "login" ? "Connexion" : "Créer un compte"}</h1>
      <p className="mt-3 text-sm text-neutral-500">
        {mode === "login" ? "Accédez à votre espace membre Vytali." : "Rejoignez la communauté comme membre."}
      </p>

      <form onSubmit={submit} className="mt-10 space-y-8" data-testid="login-form">
        {mode === "register" && (
          <div>
            <label className="vb-label">Nom affiché</label>
            <input className="vb-input" required minLength={2} value={form.display_name} onChange={set("display_name")} data-testid="register-name" />
          </div>
        )}
        <div>
          <label className="vb-label">Courriel</label>
          <input className="vb-input" type="email" required value={form.email} onChange={set("email")} data-testid="login-email" />
        </div>
        <div>
          <label className="vb-label">Mot de passe</label>
          <input className="vb-input" type="password" required minLength={8} value={form.password} onChange={set("password")} data-testid="login-password" />
        </div>
        {error && (
          <div className="text-sm text-[#FF3B30]" data-testid="login-error">
            {error}
          </div>
        )}
        <button type="submit" disabled={busy} className="vb-btn vb-btn-primary w-full disabled:opacity-40" data-testid="login-submit">
          {busy ? "…" : mode === "login" ? "Se connecter" : "Créer mon compte"}
        </button>
      </form>

      <button
        onClick={() => {
          setMode(mode === "login" ? "register" : "login");
          setError("");
        }}
        data-testid="login-toggle-mode"
        className="mt-8 text-sm text-neutral-400 hover:text-white transition-colors"
      >
        {mode === "login" ? "Pas de compte ? Créer un compte" : "J'ai déjà un compte"}
      </button>

      <div className="mt-10 text-sm text-neutral-500">
        Vous voulez participer comme Ambassadeur, Créateur ou Talent ?{" "}
        <Link to="/rejoindre" data-testid="login-join-link" className="text-[#FF2E63] hover:underline">
          Rejoindre VytaliBoots
        </Link>
      </div>
    </div>
  );
}
